import React, { useMemo } from 'react';
import {
  DEFAULT_CITY,
  DEFAULT_STREET_ADDRESS,
  MACRO_PROGRAMMING_TYPE,
  NO_DATA_TO_SHOW,
} from 'spw-constants';
import { IBuilding, IFloor, IProject } from 'spw-redux/modules/projects/types';
import { MarginTop16 } from 'spw-shared/globalComponents/containers';
import { isDepartmentScenario } from 'spw-components/worksheet/utils';
import { isTotalProgram } from 'spw-components/programming-scenarios/building-hs-sc-scenario/utils';
import { formatAddress } from 'spw-components/address-autocomplete/utils';
import {
  ProjectName,
  SubHeader,
  Card,
} from '../macro-single-page-summary/styles';
import { CardTitle } from './styles';
import { PlainProgramScenario } from '../../../../models/Scenario';

export const ProjectOverview = ({
  scenario,
  building,
  project,
  height,
}: {
  scenario: PlainProgramScenario;
  building: IBuilding;
  project: IProject;
  height?: string;
}) => {
  const scenarioFloor = useMemo(() => {
    if (building)
      return building.floors?.find(
        (floor: IFloor) => floor.id === scenario.floorId
      );
    return undefined;
  }, [scenario, building]);

  const defaultFloorName =
    isTotalProgram(scenario) || isDepartmentScenario(scenario)
      ? 'NA'
      : 'Building';

  return (
    <Card key="summary-data" style={{ height, boxSizing: 'border-box' }}>
      <div>
        <CardTitle data-testid="programming_ps_project_overview_title">
          PROJECT OVERVIEW
        </CardTitle>
        <ProjectName data-testid="programming_ps_project_overview_projectName">
          {project.projectName}
        </ProjectName>{' '}
        <SubHeader
          className="no-padding"
          data-testid="programming_ps_project_overview_streetAddress"
        >
          {building?.streetAddress &&
          building.streetAddress !== DEFAULT_STREET_ADDRESS
            ? building?.streetAddress
            : ''}
        </SubHeader>
        {(building?.city && building.city !== DEFAULT_CITY) ||
        building?.state ? (
          <SubHeader data-testid="programming_ps_project_overview_city">
            {formatAddress(building)}
          </SubHeader>
        ) : (
          <MarginTop16 />
        )}
        {scenario.calculatorType !== MACRO_PROGRAMMING_TYPE && (
          <>
            <ProjectName data-testid="programming_ps_project_overview_floorName">
              {scenarioFloor ? scenarioFloor.name : defaultFloorName}
            </ProjectName>
            <SubHeader
              className="label"
              data-testid="programming_ps_project_overview_floorName_label"
            >
              Floor Name
            </SubHeader>
          </>
        )}
        <ProjectName data-testid="programming_ps_project_overview_scenarioName">
          {scenario.name}
        </ProjectName>
        <SubHeader className="label">Program Scenario</SubHeader>
        <ProjectName data-testid="programming_ps_project_overview_industry">
          {project?.client?.industry?.name
            ? project?.client?.industry?.name
            : NO_DATA_TO_SHOW}
        </ProjectName>
        <SubHeader className="label">Industry</SubHeader>
        <ProjectName data-testid="programming_ps_project_overview_projectNumber">
          {project?.projectNumber ? project?.projectNumber : NO_DATA_TO_SHOW}
        </ProjectName>
        <SubHeader className="label">Project Number</SubHeader>
      </div>
    </Card>
  );
};
